import { Request, Response, NextFunction } from 'express';
import { AuthRequest } from '../../middleware/auth.middleware';
import * as service from './settings.service';
import { getIo } from '../../realtime/socket.bootstrap';

export async function createCompany(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    const company = await service.createCompany(req.body);
    getIo()?.emit('COMPANY_CREATED', company);
    res.status(201).json({ success: true, data: company });
  } catch (err) {
    next(err);
  }
}

export async function listCompanies(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    const companies = await service.listCompanies();
    res.json({ success: true, data: companies });
  } catch (err) {
    next(err);
  }
}

export async function deleteCompany(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    await service.deleteCompany(req.params.id);
    getIo()?.emit('COMPANY_DELETED', { companyId: req.params.id });
    res.json({ success: true, message: 'Company deleted successfully' });
  } catch (err) {
    next(err);
  }
}

export async function createDepartment(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    const department = await service.createDepartment(req.body);
    getIo()?.emit('DEPARTMENT_CREATED', department);
    res.status(201).json({ success: true, data: department });
  } catch (err) {
    next(err);
  }
}

export async function listDepartments(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    const { companyId } = req.query;
    const departments = await service.listDepartments(companyId as string);
    res.json({ success: true, data: departments });
  } catch (err) {
    next(err);
  }
}

export async function deleteDepartment(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    await service.deleteDepartment(req.params.id);
    getIo()?.emit('DEPARTMENT_DELETED', { departmentId: req.params.id });
    res.json({ success: true, message: 'Department deleted successfully' });
  } catch (err) {
    next(err);
  }
}

export async function updateCompany(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    const company = await service.updateCompany(req.params.id, req.body);
    getIo()?.emit('COMPANY_UPDATED', company);
    res.json({ success: true, data: company });
  } catch (err) {
    next(err);
  }
}

export async function updateDepartment(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    const department = await service.updateDepartment(req.params.id, req.body);
    getIo()?.emit('DEPARTMENT_UPDATED', department);
    res.json({ success: true, data: department });
  } catch (err) {
    next(err);
  }
}
